var shareSocials = document.querySelectorAll('.js-share-buttons');

if (shareSocials.length > 0) {
    var url = document.URL;

    shareSocials.forEach(shareSocial => {
        shareSocial.querySelector(".js-share-facebook")?.setAttribute("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));
        shareSocial.querySelector(".js-share-linkedin")?.setAttribute("href", "https://www.linkedin.com/shareArticle?mini=true&url=" + url);

        var copyBtn = shareSocial.querySelector(".js-copy-btn")
        copyBtn.addEventListener('click', (e) => {

            if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(() => {
                    showCopyFeedback();
                }).catch(err => {
                    console.error('Erreur clipboard API:', err);
                    showManualCopyAlert(url);
                });
            } else {
                showManualCopyAlert(url);
            }
        })


        function showCopyFeedback() {
            var copyText = shareSocial.querySelector('.js-copy-text');
            if (copyText) {
                copyText.textContent = 'Lien copié !';
            }
        }

        function showManualCopyAlert(text) {
            alert('Impossible de copier le lien automatiquement. Veuillez copier manuellement: ' + text);
        }
    })
}